import styled from "styled-components";
import Table from "./Table";

/**
 * Border-below header instead of `Table`'s own filled-background stripe + hard drop-shadow —
 * matches the same treatment applied to `Tabs`' `TabWrapper` and Spotter's own `Card`/`CardTitle`.
 * Kept as a wrapping override here rather than edited directly into `Table.tsx`, since `Table` may
 * get replaced wholesale by an updated version pulled in from another project — this stays valid
 * independent of that swap instead of being a source of merge conflicts inside the base file.
 */
const ThemedTable = styled(Table)`
  > header {
    background-color: transparent;
    border-bottom: 1px solid var(--dark300);
    box-shadow: none;
  }
` as typeof Table;

export default ThemedTable;
